/**
 * @file Contains helpers for composeMetaTitle container
 */

import { TextFieldProps } from '@mui/material';
import { RefObject } from 'react';

import {
  MESSAGE__MAX_TITLE_LENGTH,
  MESSAGE__TITLE_REQUIRED,
} from '../../../../../constants/forms';
import { getValidityProps } from '../../../../MUI/TextInput/helpers';

type ValidationResults = {
  error: NonNullable<TextFieldProps['error']>;
  helperText: NonNullable<TextFieldProps['helperText']>;
};

const defaultValidationResults: ValidationResults = {
  error: false,
  helperText: '',
};

/**
 * Get validation results for meta title
 *
 * @param ref            Reference to the input
 * @param shouldValidate Whether validation should be triggered
 * @param value          The value of input
 *
 * @returns              Object with error(boolean) and helperText(string) properties
 */
export const getValidationResults = (
  ref: RefObject<HTMLInputElement>,
  shouldValidate: boolean,
  value: string,
): ValidationResults => {
  if (!shouldValidate) {
    return defaultValidationResults;
  }

  const isValid = ref?.current?.checkValidity() === true;

  const { error, helperText } = getValidityProps(
    MESSAGE__TITLE_REQUIRED,
    value,
    MESSAGE__MAX_TITLE_LENGTH,
  );

  const shouldShowError = !isValid || error;

  return { error: shouldShowError, helperText };
};
